const selectAppBarTitle = state => state.ui.layout.appBarTitle

const selectLoading = state => state.ui.layout.loading

const selectFetchIds = state => state.ui.layout.fetchIds

const selectDrawerMenuOpen = state => state.ui.layout.drawerMenuOpen

const selectChatDrawerOpen = state => state.ui.layout.chatDrawerOpen

const selectChatDrawerPanel = state => state.ui.layout.chatDrawerPanel

const selectMainChatDeviceId = state => state.ui.layout.mainChatDeviceId

const selectMainChatChatGroupId = state => state.ui.layout.mainChatChatGroupId

const selectFramelessModeTurnedOn = state => state.ui.layout.framelessModeTurnedOn

const LayoutSelectors = {
  appBarTitle: selectAppBarTitle,
  loading: selectLoading,
  fetchIds: selectFetchIds,
  drawerMenuOpen: selectDrawerMenuOpen,
  chatDrawerOpen: selectChatDrawerOpen,
  chatDrawerPanel: selectChatDrawerPanel,
  mainChatDeviceId: selectMainChatDeviceId,
  mainChatChatGroupId: selectMainChatChatGroupId,
  framelessModeTurnedOn: selectFramelessModeTurnedOn
}

export default LayoutSelectors
